import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {UIMMatchmakingController} from './UIMMatchmakingController'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

type MatchmakingClassic4PTypes = MatchmakingMatchTypes.RankedClassic4P | MatchmakingMatchTypes.UnrankedClassic4P

export class UIMMatchmakingSearchingClassic4PView extends UIMMatchmakingSearchingView<MatchmakingClassic4PTypes> {
    constructor(matchmakingController: UIMMatchmakingController, matchType: MatchmakingClassic4PTypes) {
        const loadingText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.searchingForOpponents'}
        const isRanked = matchType == MatchmakingMatchTypes.RankedClassic4P
        const player4Ranked: TranslationObject = {key: 'strings:homePage.matchmakingPopup.ranked4Player.title'}
        const player4Unranked: TranslationObject = {key: 'strings:homePage.unranked.4Player'}
        const title = isRanked ? player4Ranked : player4Unranked
        const imageSrc = LobbyImage.GameModeBase

        super(matchmakingController, title, imageSrc, loadingText, matchType)
    }

    addTitle() {
        super.addTitle()
        this.setTimeElapsedCounter()
    }
}
